import axios from "axios";

const baseURL =
  window.location.hostname === "localhost"
    ? process.env.REACT_APP_BACKEND_URL_LOCAL + "/api"
    : process.env.REACT_APP_BACKEND_URL_PROD + "/api";

export const getFamilles = async () => {
  const res = await axios.get(`${baseURL}/familles`);
  return res.data;
};
